import Vue from 'vue'

Vue.prototype.$tips = function (title, content) {
  title = title ? title : this.$t('Tips')
  content = content ? content : this.$t('Incomplete information')
	var okText = this.$t('OK')
  this.$Modal.error({
    title,
    content,
		okText
  });
}



// WEBPACK FOOTER //
// ./src/utils/tips.js